import { classNames } from 'primereact/utils';

import { emissionValueWithDecimals } from '../../../../../../../../../../../../shared/helpers/emission-value-with-decimals';
import {
  EmissionSymbol,
  IProcessDetails,
} from '../../../../../../../../../../../../shared/interfaces/IFootprint';
import styles from '../../CalculationDetails.module.css';
import { getMaterialsTableRows, getMaterialsTotalEmissions } from '../../helpers';
import EnergyTable from '../EnergyTable';
import MaterialsAndWasteTreatmentTable from '../MaterialsAndWasteTreatmentTable';

type IndividualProcessCardProps = {
  process: IProcessDetails;
};

const IndividualProcessCard = ({ process }: IndividualProcessCardProps): JSX.Element => {
  const materialsTotal = getMaterialsTotalEmissions(
    getMaterialsTableRows(process?.input_materials),
  );
  const energyTotal = process?.total_machine_emissions;

  // Same two figures as the footers of the tables below. Undefined when neither table has a value.
  const processTotal =
    materialsTotal == null && energyTotal == null
      ? undefined
      : (materialsTotal ?? 0) + (energyTotal ?? 0);

  return (
    <div
      className={classNames('p-4 border-round-2xl flex w-full flex-column gap-5', styles['card'])}
    >
      {/* Process Name */}
      <div className='flex flex-row flex-wrap align-items-baseline justify-content-between gap-2'>
        <h5 className='p-0 m-0 font-medium'>{process?.name}</h5>

        {processTotal != null && (
          <span className='white-space-nowrap'>
            <span className='font-semibold'>{emissionValueWithDecimals(processTotal)}</span>
            <span className='text-color-secondary'>&nbsp;{EmissionSymbol.KG_CO2E}</span>
          </span>
        )}
      </div>

      {/* Input materials, each with its own waste treatment */}
      <MaterialsAndWasteTreatmentTable materials={process?.input_materials} />

      {/* Energy sources */}
      <EnergyTable machines={process?.machines} totalEmissions={process?.total_machine_emissions} />
    </div>
  );
};

export default IndividualProcessCard;
